import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement, SlotsController } from '@phase2/outline-core';
import { customElement, property, query } from 'lit/decorators.js';
import componentStyles from './outline-org-chart-panel.css.lit';
import '../../outline-icon-baseline/outline-icon-baseline';
/**
 * The OutlineOrgChartBaselinePanel component
 * @element outline-org-chart-panel
 */
@customElement('outline-org-chart-panel')
export class OutlineOrgChartBaselinePanel extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotsController(this);

  @property({ type: String, attribute: 'aria-label' })
  ariaLabel: string;

  /**
   * Wether the panel is active/open.
   * Controlled by parent org-chart component.
   */
  @property({ type: Boolean, reflect: true, attribute: true })
  active = false;

  /**
   * Used to provided a unique ID
   * for org-chart component and accessibility purposes.
   */
  @property({ type: String, reflect: true })
  id: string = Math.floor(Math.random() * 10000).toString();

  @property({ type: Boolean, attribute: 'has-children', reflect: true })
  hasChildren: boolean;

  /**
   * Used to provided a unique ID
   * for org-chart component and accessibility purposes.
   */
  @property({ type: Boolean, attribute: 'enable-border-bottom' })
  addContentBorder = false;

  @query('.org-chart-panel--button')
  buttonRef: HTMLButtonElement;

  render(): TemplateResult {
    const isActive = this.active ? 'active' : 'inactive';
    const hasContentBorder = this.addContentBorder
      ? 'enable-border-bottom'
      : '';

    return html`<section class="org-chart-panel">
      ${this.hasChildren
        ? html`
            <div class="org-chart-panel--heading">
              ${this.slots.conditionalSlot('heading', false)}
              <button
                class="org-chart-panel--button ${isActive}"
                id="${this.id}-button"
                aria-expanded=${this.active}
                aria-controls="${this.id}-info"
                @click=${this.setActive}
                aria-label="expand ${this.ariaLabel}"
              >
                <span class="org-chart-panel--icon ${isActive}">
                  <outline-icon-baseline
                    library="system"
                    name="${this.active ? 'eu-minus' : 'eu-plus'}"
                    size="16px"
                  ></outline-icon-baseline>
                </span>
              </button>
            </div>
            <div
              class="org-chart-panel--content ${hasContentBorder}"
              role="region"
              aria-labelledby="${this.id}-button"
              id="${this.id}-info"
              aria-hidden="${!this.active}"
            >
              <slot></slot>
            </div>
          `
        : html`
            <div
              class="org-chart-panel--heading org-chart-panel--heading--no-children"
            >
              ${this.slots.conditionalSlot('heading', false)}
            </div>
          `}
    </section>`;
  }

  setActive() {
    this.active = !this.active;
  }
}
